import axiosInstance from './api'
import {
	shouldUseApplicationFlowFixtures,
	fixtureFetchAppAssignments,
} from 'fixtures/applicationFlowFixtures'

export const fetchAppAssignments = async () => {
	if (shouldUseApplicationFlowFixtures()) return fixtureFetchAppAssignments()

	const response = await axiosInstance.get('/counseling/app-assignments')
	return response.data || {}
}
